export function mapCoordinates(property) {
  const latRaw=property?.latitude ?? property?.location?.latitude;
  const lonRaw=property?.longitude ?? property?.location?.longitude;
  if([latRaw,lonRaw].some(value=>value==null || String(value).trim()===''))return null;
  const lat=Number(latRaw),lon=Number(lonRaw);
  return Number.isFinite(lat)&&Number.isFinite(lon)&&Math.abs(lat)<=90&&Math.abs(lon)<=180?{lat,lon}:null;
}
